import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    activities: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_ACTIVITY_SELECT_IDS (store, ids) {
      store.activities.selectIds = ids
    },
    REMOVE_ACTIVITY_SELECT_IDS (store, ids) {
      store.activities.selectIds = store.activities.selectIds.filter((v) => { return !ids.includes(v) })
    },
    ADDEND_ACTIVITY_SELECT_IDS (store, ids) {
      store.activities.selectIds = store.activities.selectIds.concat(ids)
    },
    ADDINIT_ACTIVITY_SELECT_IDS (store, ids) {
      store.activities.selectIds = ids.concat(store.activities.selectIds)
    },
    SET_ACTIVITY_SELECT_ID (store, id) {
      store.activities.selectId = id
    },
    SET_ACTIVITY_FILTERS (store, filters) {
      store.activities.filters = filters
    },
    SET_ACTIVITY_PAGINATE (store, val) {
      store.activities.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getActivities: (store, getters) => {
      return store.activities.selectIds.map((id) => {
        return getters['entities/activities/find'](id)
      })
    },
    getActivitiesFilters: (store, getters) => {
      return store.activities.filters
    },
    getActivitiesPaginate: (store, getters) => {
      return store.activities.paginate
    },
    getActivity: (store, getters) => {
      return getters['entities/activities/find'](store.activities.selectId) || {}
    }
  },
  actions: {
    /*
    selectActivities
    */
    selectActivities ({commit, dispatch, getters, state}, filters) {
      return dispatch('getActivities', filters)
      .then((response) => {
        commit('SET_ACTIVITY_FILTERS', filters)
        commit('SET_ACTIVITY_PAGINATE', response)
        commit('SET_ACTIVITY_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    selectMoreActivities
    */
    selectMoreActivities ({commit, dispatch, getters, state}, filters) {
      return dispatch('getActivities', filters)
      .then((response) => {
        commit('SET_ACTIVITY_PAGINATE', response)
        commit('ADDEND_ACTIVITY_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectActivities
    */
    refreshSelectActivities ({commit, dispatch, getters, state}) {
      return dispatch('selectActivities', getters.getActivitiesFilters)
    },
    /*
    selectActivity
    */
    selectActivity ({commit, dispatch, getters, state}, id) {
      return dispatch('getActivityById', id)
      .then((response) => {
        commit('SET_ACTIVITY_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getActivities
    */
    getActivities ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/activities`, {params: filters})
      .then((response) => {
        return dispatch('entities/activities/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.activities || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getActivityById
    */
    getActivityById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/activities/${id}`)
      .then((response) => {
        return dispatch('entities/activities/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.activities[0]
      })
    },
    /*
    deleteActivity
    */
    deleteActivity ({commit, dispatch, getters, state}, id) {
      commit('REMOVE_ACTIVITY_SELECT_IDS', [id])
      return dispatch('entities/activities/delete', id)
    },
    /*
    socketActivity
    */
    socketActivity ({commit, dispatch, getters, state}, message) {
      const {
        method,
        _id,
        candidateId
      } = message

      const ids = [...state.activities.selectIds, state.activities.selectId]
      if (method === 'update' && ids.includes(_id)) {
        dispatch('getActivityById', _id)
      }
      if (method === 'create' && getters.getCandidate && getters.getCandidate._id === candidateId) {
        dispatch('getActivityById', _id).then(res => {
          console.log(_id)
          commit('ADDINIT_ACTIVITY_SELECT_IDS', [res._id])
        })
      }
      if (method === 'delete' && ids.includes(_id)) {
        commit('REMOVE_ACTIVITY_SELECT_IDS', [_id])
        dispatch('entities/activities/delete', _id)
        if (state.activities.selectId === _id) {
          commit('SET_ACTIVITY_SELECT_ID', null)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Activity.js